import { effectorSocket } from '../lib/effector-socket';
import { createLabmateSdk } from '../lib/labmate-sdk';

export const wsClient = effectorSocket("ws://localhost:1337");
export const labmateClient = createLabmateSdk("ws://localhost:3000");

wsClient.connectFx();
labmateClient.connect();